<template>
  <svg class="_component-icon-plus" :style="componentStyle" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 2V9H18V11H10.999L11 18H9L8.999 11H2V9H9V2H11Z" fill="#17181A" />
  </svg>
</template>
<script>
/**
 * @module Plus
 * @desc icon 组件 plus
 */
export default {
  name: 'Plus',
  /**
   * @prop { String } color 颜色
   */
  props: {
    color: {
      type: String,
      default: '#17181A'
    }
  },
  /**
   * @member { Object } componentStyle 组件style
   */
  computed: {
    componentStyle() {
      return {
        fill: this.color
      };
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
